import {Inject, Injectable, Renderer2, RendererFactory2, DOCUMENT} from '@angular/core';

interface Scripts {
  name: string;
  src: string;
}
// reserved for future use  in case  we need to load more scripts
export const ScriptStore: Scripts[] = [
  // { name: 'chilliStudio', src: 'https://studio-cdn.chiligrafx.com/studio-ui/latest/bundle.js' },
];

@Injectable()
export class ScriptService {
  private renderer: Renderer2;
  private scripts: Record<string, { loaded: boolean; src: string }> = {};


  constructor(rendererFactory: RendererFactory2, @Inject(DOCUMENT) private document: Document) {
    this.renderer = rendererFactory.createRenderer(null, null);
    ScriptStore.forEach((script: Scripts) => {
      this.scripts[script.name] = {
        loaded: false,
        src: script.src
      };
    });
  }

  public loadScripts() {
    // load  chili studio ui as module script
    this.loadChiliStudioModuleScript();

    ScriptStore.forEach( s => this.loadScript(s));
  }

  private loadScript(scriptSource: Scripts ) {

    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = scriptSource.src;
    this.renderer.appendChild(this.document.body, script);
    return script;
  }

  private loadChiliStudioModuleScript(): HTMLScriptElement {
     const script = this.renderer.createElement('script');
     script.type = 'module';
     script.textContent = `
      import('https://studio-cdn.chiligrafx.com/studio-ui/latest/es-module/bundle.js').then((module) => {
        window.StudioUI = module.default;
      });
    `;
     this.renderer.appendChild(this.document.body, script);
     return script;
 }
}
